<div class="row" *ngIf="lgvClientSvc.IsSSReady$ | async">
    <div class="col-12">
        <mat-card>
            <mat-card-subtitle>
                <div class="row labelValue">

                    <div class="col-6">
                        <h2>{{property.propertyInfo.address}} <br>
                            {{property.propertyInfo.city}},
                            {{property.propertyInfo.state}} {{property.propertyInfo.zip}}</h2>
                        <br />
                        <h2 class="standOutText current-value">
                            Current Value: ${{ property.propertyInfo.avmestimatedValue | number : '1.0-0' }}
                        </h2>
                    </div>

                    <div class="col-5">

                        <!--Owned Properties-->
                        <div *ngIf="property.associationType === 'Owned'" class="row">
                            <div class="col-6">
                                <div class="label">AVM Low</div>
                                <div class="value">
                                    ${{property.propertyInfo.avmlowValue | number : '1.0-0'}}
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="label">Beds</div>
                                <div class="value">{{property.propertyInfo.bedrooms}}</div>
                            </div>
                            <div class="col-6">
                                <div class="label">AVM High</div>
                                <div class="value">
                                    ${{property.propertyInfo.avmhighValue | number :'1.0-0'}}
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="label">Baths</div>
                                <div class="value">{{property.propertyInfo.totalBaths}}</div>
                            </div>
                            <div class="col-6">
                                <div class="label">AVM Processed</div>
                                <div class="value">
                                    {{property.propertyInfo.avmprocessedDate |date:'MM/dd/yy'}}
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="label">Year Built</div>
                                <div class="value">{{property.propertyInfo.yearBuilt}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-1">
                        <div class="float-end ellipsisMenuWrapper">
                            <button mat-button [matMenuTriggerFor]="propertyMenu">
                                <fa-icon style="font-size:18px !important;" icon="bars"></fa-icon>
                            </button>
                            <mat-menu #propertyMenu="matMenu">
                                <div class="ellipsisMenuContent">
                                    <!-- <button (click)="goToPropertyDashboard(property?.propertyInfo?.id)"
                                        mat-menu-item><fa-icon icon="chart-line"></fa-icon>&nbsp;&nbsp;
                                        Dashboard</button> -->

                                    <!--Prospect-->
                                    <!--<ng-container *ngIf="hasProspectProperties">
                                        <ng-container *ngIf="loanScenario">
                                            <button mat-menu-item
                                                (click)="onPriceThisScenario(property.propertyInfo.id, loanScenario.id)">
                                                <fa-icon style="font-size:18px !important;"
                                                    icon="dollar-sign"></fa-icon>&nbsp;&nbsp;
                                                Price
                                            </button>
                                            <button mat-menu-item
                                                (click)="onEditThisScenario(property.propertyInfo.id, loanScenario)">
                                                <fa-icon style="font-size:18px !important;"
                                                    icon="edit"></fa-icon>&nbsp;&nbsp;
                                                Edit Loan Scenario
                                            </button>
                                        </ng-container>
                                    </ng-container>-->

                                    <button mat-menu-item (click)="onOpenPublicRecords(property)"><fa-icon
                                            style="font-size:18px !important;" icon="folder-open"></fa-icon>&nbsp;&nbsp; Public Record History</button>
                                    <button *ngIf="property.associationType === 'Owned'" mat-menu-item
                                        (click)="onGoToCreateLoan(property)"><fa-icon style="font-size:18px !important;"
                                            icon="plus"></fa-icon>&nbsp;&nbsp;
                                        Create Loan Manually</button>
                                    <!-- <button mat-menu-item><fa-icon style="font-size:18px !important;"
                                            style="font-size:18px !important;" icon="star"></fa-icon>&nbsp;&nbsp; Make
                                        Primary Property</button> -->
                                    <!-- <button mat-menu-item><fa-icon style="font-size:18px !important;"
                                            style="font-size:18px !important;" icon="pencil-alt"></fa-icon>&nbsp;&nbsp;
                                        Edit</button> -->
                                    <button mat-menu-item (click)="removeClient()"><fa-icon
                                            style="font-size:18px !important;" style="font-size:18px !important;"
                                            icon="trash"></fa-icon>&nbsp;&nbsp;
                                        Remove Property</button>
                                </div>

                            </mat-menu>
                        </div>
                    </div>
                    <!--<div class="col-2"><div style="float:right;font-size:24px;"><a><fa-icon icon="edit"></fa-icon></a></div></div>-->
                </div>
            </mat-card-subtitle>

            <!--Prospect Properties-->
            <div *ngIf="property.associationType === 'Prospect'" class="row labelValue">
                <div class="col-4">
                    <div class="label">AVM Low</div>
                    <div class="value">
                        ${{property.propertyInfo.avmlowValue | number : '1.0-0'}}
                    </div>
                </div>
                <div class="col-4">
                    <div class="label">Beds</div>
                    <div class="value">{{property.propertyInfo.bedrooms}}</div>
                </div>
                <div class="col-4">
                    <div class="label">Year Built</div>
                    <div class="value">{{property.propertyInfo.yearBuilt}}</div>
                </div>
                <div class="col-4">
                    <div class="label">AVM High</div>
                    <div class="value">
                        ${{property.propertyInfo.avmhighValue | number :'1.0-0'}}
                    </div>
                </div>
                <div class="col-4">
                    <div class="label">Baths</div>
                    <div class="value">{{property.propertyInfo.totalBaths}}</div>
                </div>
                <div class="col-4">
                    <div class="label">Property Type</div>
                    <div class="value">{{property.propertyType}}</div>
                </div>
                <div class="col-4">
                    <div class="label">AVM Processed</div>
                    <div class="value">
                        {{property.propertyInfo.avmprocessedDate |date:'MM/dd/yy'}}
                    </div>
                </div>
                <div class="col-4">
                    <div class="label">House Size</div>
                    <div class="value">
                        {{property.propertyInfo.livingArea | null}} sq. ft.
                    </div>
                </div>
                <div class="col-4">
                    <div class="label">Lot Size</div>
                    <div class="value">
                        {{property.propertyInfo.lotSize | null }} sq. ft.
                    </div>
                </div>
            </div>
            <br />
            <br>
            <!--Prospect Opportunities-->
            <!-- <ng-container *ngIf="property.associationType === 'Prospect'">
                <div class="col-12 loan-container" *ngIf="(lgvClientSvc.opportunitiesForSelectedProperty$ | async)?.length > 0">
                    <div class="row labelValue">
                        <div class="col-11">
                            <h4>Loan Opportunities</h4>
                        </div>
                        <div class="coll-1">
                            <div class="float-end">
                                <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                                    <fa-icon style="font-size:18px;" icon="bars"></fa-icon>
                                </button>
                                <mat-menu #LoanActionMenu="matMenu">
                                    <button *ngIf="(lgvUserService.IsReadyForPricing$ | async) && (lgvCompanySvc.isMortgageCompany$ | async)" mat-menu-item
                                        (click)="loadProspectPropertyLoanOpportunities(property?.loanScenarios)">Refresh
                                        Opportunities</button>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="Vert-30 col-md-12"></div>

                        <div class="col-12">

                            <lgv-loading-indicator *ngIf="isLoadingOpportunities$ | async"
                                [CSSClass]="'Small'"></lgv-loading-indicator>

                            <div *ngIf="(lgvClientSvc.opportunitiesForSelectedProperty$ | async) as OpportunityList">
                                <table class='table table-striped table-bordered'>
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Product</th>
                                            <th>Est. Fees</th>
                                            <th>Payment</th>
                                            <th>Rate</th>
                                            <th>APR</th>
                                            <th>Term</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let o of OpportunityList">
                                            <td>{{o.opportunityType.name}}</td>
                                            <td>{{o.opportunityInfo.productName}}</td>
                                            <td>${{o.opportunityInfo.paymentSavings | number : '1.0-0' | null}}</td>
                                            <td>${{o.opportunityInfo.marketPayment | number : '1.0-0' | null}}</td>
                                            <td>{{o.opportunityInfo.matchedRate | number : '1.3-3'}}%</td>
                                            <td>{{o.opportunityInfo.matchedApr | number : '1.3-3'}}%</td>
                                            <td>{{o.opportunityInfo.loanTermMonths}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>

                    </div>
                </div>
            </ng-container> -->

            <!--#region Current Loan-->
            <ng-container *ngIf="activeLoans?.length > 0">

                <h4>Active Loans</h4>

                <div class="col-12 loan-container" *ngFor="let Loan of activeLoans">

                    <div class="row labelValue">

                        <div class="col-12 standOutText current-value">
                            {{Loan.loanAnalysis.interestRate | number : '1.3-3'}}% Rate |
                            {{Loan.loanAnalysis.loanType }} {{Loan.loanAnalysis.progType }} |
                            {{SSHlpr.LoanTermYears | number : '1.0-2'}} Year Term

                            <div class="float-end">
                                <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                                    <fa-icon style="font-size:18x;" icon="bars"></fa-icon>
                                </button>
                                <mat-menu #LoanActionMenu="matMenu">
                                    <button mat-menu-item (click)="OpenEditLoanDialog(Loan)"><fa-icon class="editIcon"
                                            icon="edit"></fa-icon>&nbsp;&nbsp; Edit
                                        Loan</button>
                                    <button mat-menu-item (click)="removeLoan(Loan)"><fa-icon
                                            icon="trash"></fa-icon>&nbsp;&nbsp;
                                        Remove Loan</button>
                                    <!-- <button mat-menu-item title="Load in pricing new tab"
                                        *ngIf="lgvUserService.IsAdmin || (lgvCompanySvc.isMortgageCompany$ | async)">
                                        <a [href]="'/#/admin/pricing-search/client/' + ClientIDParam +'/property/' + property.propertyInfo.id  +'/loan/' + Loan.loanInfo.id"
                                            target="_blank"> <fa-icon icon="dollar-sign"></fa-icon>&nbsp;&nbsp;
                                            Price this
                                            loan</a>
                                    </button> -->
                                </mat-menu>
                            </div>

                        </div>
                        <div *ngIf="Loan.lienType.name !== 'First Mortgage'" class="col-12">
                            [{{Loan.lienType.name}}]
                        </div>

                        <div class="Vert-10 col-md-12"></div>

                        <div class="col-3">
                            <div class="label">Closing Date</div>
                            <div class="value">{{Loan.loanInfo.closingDate | date:'MM/dd/yy'}}</div>
                        </div>
                        <div class="col-3">
                            <div class="label">Type</div>
                            <div class="value">{{Loan.loanAnalysis.loanType }}</div>
                        </div>
                        <div class="col-3">
                            <div class="label">Program</div>
                            <div class="value">{{Loan.loanAnalysis.progType }}</div>
                        </div>
                        <div class="col-3">
                            <div class="label">Current Balance</div>
                            <div class="value">${{(!Loan.loanInfo.clientEstimatedBalance ? Loan.loanAnalysis.estimatedBalance :
                                Loan.loanInfo.clientEstimatedBalance) | number :
                                '1.0-0'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="label">Term</div>
                            <div class="value">{{Loan.loanAnalysis.loanTerm }}</div>
                        </div>
                        <div class="col-3">
                            <div class="label">Payment</div>
                            <div class="value">${{Loan.loanInfo.monthlyPayment | number : '1.0-0'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="label">Loan #</div>
                            <div class="value">{{Loan.loanInfo.loanNumber}}</div>
                        </div>
                        <div class="col-3">
                            <div class="label">Original Amount</div>
                            <div class="value">${{Loan.loanAnalysis.totalMortgageLoanAmount | number
                                :'1.0-0'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="label">Total Monthly Payment</div>
                            <div class="value">
                                ${{Loan.loanInfo.totalMonthlyPayment | number : '1.0-0'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="label">HOA</div>
                            <div class="value">${{Loan.loanInfo.hoadues | number : '1.0-0'}}</div>
                        </div>
                        <div class="col-3">
                            <div class="label">Flood Ins</div>
                            <div class="value">${{Loan.loanInfo.floodInsurance | number : '1.0-0'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="label">Hazard Ins</div>
                            <div class="value">${{Loan.loanInfo.hazardInsurance | number : '1.0-0'}}
                            </div>
                        </div>

                    </div>

                </div>


            </ng-container>
            <!--#endregion Current Loan-->

            <ng-container>
                <div class="Vert-30"></div>
                <lgv-pricing-scenario-viewer *ngIf="lgvUserService.AgentSS$ | async as agentSS" [clientID]="clientIdParam"
                    [pricingScenarios$]="lgvClientSvc.scenariosForSelectedProperty$"
                    [isPropertyless]="false" [loanId]="activeLoans[0]?.loanInfo?.id" [property]="property"
                    [opportunities$]="lgvClientSvc.opportunitiesForSelectedProperty$ "
                    [agentSS]="agentSS"></lgv-pricing-scenario-viewer>
            </ng-container>

            <!--#region Loan History-->
            <ng-container *ngIf="inactiveLoans as InactiveLoansList">


                <div class="col-12" *ngIf="inactiveLoans?.length>0">
                    <div class="Vert-30"></div>
                    <h4>Loan History</h4>
                </div>

                <div class="col-12" *ngFor="let Loan of  inactiveLoans">
                    <mat-card>
                        <mat-card-subtitle>
                            <div class="row labelValue">
                                <div class="col-12 standOutText">
                                    {{Loan.loanInfo.interestRate | number : '1.3-3'}}% Rate |
                                    {{Loan.loanAnalysis.loanType }} {{Loan.loanAnalysis.progType }} |
                                    {{SSHlpr.LoanTermYears }} Year Term
                                </div>

                                <div class="Vert-10 col-md-12"></div>

                                <div class="col-3">
                                    <div class="label">Closing Date</div>
                                    <div class="value">{{Loan.loanInfo.closingDate | date:'MM/dd/yy'}}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Type</div>
                                    <div class="value">{{Loan.loanAnalysis.loanType }}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Program</div>
                                    <div class="value">{{Loan.loanAnalysis.progType }}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Current Balance</div>
                                    <div class="value">${{(!Loan.loanInfo.clientEstimatedBalance ? Loan.loanAnalysis.estimatedBalance :
                                        Loan.loanInfo.clientEstimatedBalance) | number :
                                        '1.0-0'}}
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Term</div>
                                    <div class="value">{{Loan.loanAnalysis.loanTerm }}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Payment</div>
                                    <div class="value">${{Loan.loanInfo.monthlyPayment | number : '1.0-0'}}
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Loan #</div>
                                    <div class="value">{{Loan.loanInfo.loanNumber}}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Original Amount</div>
                                    <div class="value">${{Loan.loanAnalysis.totalMortgageLoanAmount | number
                                        :'1.0-0'}}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Total Payments</div>
                                    <div class="value">
                                        ${{Loan.loanInfo.totalMonthlyPayment | number : '1.0-0'}}
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="label">HOA</div>
                                    <div class="value">${{Loan.loanInfo.hoadues | number : '1.0-0'}}</div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Flood Ins</div>
                                    <div class="value">${{Loan.loanInfo.floodInsurance | number : '1.0-0'}}
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="label">Hazard Ins</div>
                                    <div class="value">${{Loan.loanInfo.hazardInsurance | number : '1.0-0'}}
                                    </div>
                                </div>

                            </div>
                        </mat-card-subtitle>

                    </mat-card>
                </div>

            </ng-container>
            <!--#endregion Loan History-->
        </mat-card>
    </div>

</div>
